import type { CSSProperties } from 'react'
import Skeleton from 'react-loading-skeleton'

import { SegmentLoaderContainer } from './Segment.Styled'

type Props = {
  style: CSSProperties
}

export const SegmentLoader = ({ style }: Props) => {
  return (
    <SegmentLoaderContainer>
      <Skeleton style={style} />
    </SegmentLoaderContainer>
  )
}
